import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import TicketSaleForm from 'Services/SalesManagement/Features/TicketSale/Components/TicketSaleForm'
import useSalesManagementBreadcrumbs from 'Services/SalesManagement/Hooks/useSalesManagementBreadcrumbs'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { t } from 'ttag'

export default function TicketSaleCreatePage() {
  const title = t`Sell a new QR group ticket`
  const baseUrl = `${SALES_MANAGEMENT_ROOT_URL}/ticket-sales/qr-group-ticket-sales`
  const previousLocation = usePreviousLocation(baseUrl)
  const breadcrumbs = useSalesManagementBreadcrumbs([
    {
      title: t`Ticket sales`
    },
    {
      title: t`QR group ticket sales`,
      link: baseUrl
    },
    {
      title: title
    }
  ])

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{title}</PageTitle>
        </Grid>
      </Grid>
      <TicketSaleForm successBaseUrl={previousLocation} />
    </Box>
  )
}
